import * as React from "react";

import { cn } from "@/lib/utils";

import * as ProgressPrimitive from "@radix-ui/react-progress";

const PROGRESS_WARNING_THRESHOLD = 70;
const PROGRESS_DANGER_THRESHOLD = 90;

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value = 0, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn(
      "relative h-4 w-full overflow-hidden rounded-full bg-whisper ",
      className
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={cn(
        "h-full w-full flex-1 transition-all bg-shamrock-green",
        (value || 0) > PROGRESS_WARNING_THRESHOLD &&
          (value || 0) < PROGRESS_DANGER_THRESHOLD &&
          "bg-tangerine",
        (value || 0) >= PROGRESS_DANGER_THRESHOLD && "bg-cinnabar"
      )}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
